import React, { useState, useRef } from 'react'
import { Title } from 'utils/Title'
import { errorHandler } from 'utils/errorHandler'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import Skeleton from 'react-loading-skeleton'
import { toast, ToastContainer } from 'react-toastify'
import UsersList from './UsersList'
import { FaBolt, FaPlus } from "react-icons/fa";
import ModalUser from 'components/modals/ModalUser'
import PageMenuHeader from 'components/PageMenuHeader'
import PageMainHeader from 'components/PageMainHeader'
import Banner from '@leafygreen-ui/banner'
import Button from '@leafygreen-ui/button'
import ScrollTop from 'utils/ScrollTop'
import { AuthContext } from 'contexts/AuthContext'
import { fetchUsers } from 'utils/auth'
import _ from "lodash"
import axios from 'axios'
import { SettingsContext } from "contexts/SettingsContext";
import { Option, Select } from "@leafygreen-ui/select";

const title = 'Users'

const initialUser = {
  username: "",
  password: "",
  role: "",
}

export default function Users() {
  const [selectedUser, setSelectedUser] = useState(initialUser);
  const [msg, setMsg] = useState(null);
  const [mode, setMode] = useState("_createUser");
  const modeRef = useRef("_createUser");
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const { user } = React.useContext(AuthContext);
  const { settings } = React.useContext(SettingsContext);

  const locationCodeRef = React.useRef(null);
  
  React.useEffect(() => {
    if(user && user?.locationCode) locationCodeRef.current = user.locationCode;
  }, [user])

  // console.log("[Users] user: ", user);
  // console.log("[Users] settings: ", settings);
  const queryClient = useQueryClient();

  const { data: users, isLoading, isError, error, refetch: refetchUsers } = useQuery("users",
  () => {
    let query = {}
    if(user.username !== "super") query = {username: {$ne: "super"}}
    if(!_.isNil(locationCodeRef.current)) query["locationCode"] = locationCodeRef.current;
    return fetchUsers(query)
  }, {
    refetchOnWindowFocus: false, staleTime: 1000 * 60 * 5
  })

  // console.log('- selectedUser: ', selectedUser)
  // console.log('- users: ', users)

  const showModalHandler = ({selectedUser, mode}) => {
    console.log("* showModalHandler init");
    console.log("[showModalHandler] mode: ", mode);
    setMode(mode);
    modeRef.current = mode;
    if (msg) setMsg(null);
    if (selectedUser) {setSelectedUser(selectedUser)} else {setSelectedUser(initialUser)};
    setModalIsOpen(true)
  };

  const mutateUser = useMutation(async () => {
    console.log("* mutateUser init");
    console.log("[mutateUser] mode: ", mode);
    console.log("[mutateUser] modeRef: ", modeRef);
    let result;
    if(window?.printflo_api) {
      result = await window.printflo_api[modeRef.current](selectedUser)
      if(_.isError(result)) throw result;

    } else {
      try {
        modeRef.current = _.replace(modeRef.current, "_", "").replace("User", "");
        console.log("[mutateUser] modeRef.current:replace ", modeRef.current, typeof modeRef.current);
        let url = `/api/auth/${modeRef.current}-user`
        const response = await axios.post(url, {...selectedUser})
        result = response?.data
        
      } catch (error) {
        throw error
      }
    }
    return result
  }, {
    onError: (error) => {
      console.log("[mutateUser:onError] error: ", error)
      let retval = errorHandler(error)
      setMsg(retval);
    },
    onSuccess: (response) => {
      // console.log("[mutateUser:onSuccess] response: ", response)
      toast.info(response?.message, {
        position: "bottom-right"
      })
      queryClient.invalidateQueries("users");
    }
  })

  const submitHandler = () => {
    console.log("* submitHandler init ==");
    console.log("[submitHandler] selectedUser: ", selectedUser);
    msg && setMsg(null);
    setModalIsOpen(false)
    mutateUser.mutate()
  };

  const handleDelete = () => {
    console.log("*handleDelete init");
    // console.log("selectedUser: ", selectedUser);
    modalIsOpen && setModalIsOpen(false)
    msg && setMsg(null);
    // setMode("_deleteUser")
    modeRef.current = "_deleteUser"
    mutateUser.mutate();
  };

  const onChangeLocationCodeHander = (v) => {
    console.log("* onChangeLocationCodeHander init");
    console.log("[onChangeLocationCodeHander] v: ", v);
    if(v==="all") v = null;
    locationCodeRef.current = v;
    console.log("[onChangeLocationCodeHander] locationCode: ", locationCodeRef)
    refetchUsers();
  }
  
  return (
    <>
      <Title title={title} />
      <PageMainHeader title={title} />
      <ToastContainer theme='dark'/>
      <section className="primary">
        {isLoading ? (
          <Skeleton count={20} height={50} circle={true} />
        ) : isError ? (
          <Banner variant='danger'>
            {error?.message ? error.message : error}
          </Banner>
        ) : (
          <>
            {msg && <Banner>{msg}</Banner>}
            <PageMenuHeader>
              <div className="btn-menu-list">
                <Button
                  variant="primary"
                  className="swing-icon"
                  title="Reload"
                  leftGlyph={<FaBolt />}
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Refresh
                </Button>

                <Button
                  variant="primary"
                  className="swing-icon"
                  leftGlyph={<FaPlus />}

                  onClick={() => {
                    showModalHandler({mode: "_createUser"});
                  }}
                >
                  Add
                </Button>
              </div>
              {(settings?.useMultipleLocations && settings?.locations) && (
              <div className="input-field location-container align-items-center">
                <label htmlFor="locationCode" className="mr-10">Location:</label>
                <Select
                  value={locationCodeRef?.current ? locationCodeRef.current : 'all'}
                  onChange={(value) => onChangeLocationCodeHander(value)}
                  className="select-location"
                  placeholder="Location Options"
                  aria-labelledby="Location options"
                >
                  <Option value="all">All</Option>
                  {settings?.locations.map((location) => {
                    return (
                      <Option key={location?.code} value={location?.code}>
                        {location.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            )}      
            </PageMenuHeader>
            {
              (users && Boolean(users?.length))
                ? (<UsersList users={users} showModal={showModalHandler} settings={settings} />)
                : (<Banner>Users not found.</Banner>)
            }
          </>      
        )}
        <ModalUser 
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          title={"User"}
          mode={mode}
          user={selectedUser}
          setUser={setSelectedUser}
          submitHandler={submitHandler}
          handleDelete ={handleDelete}
          settings={settings}
        />
        <ScrollTop />
      </section>
    </>
  )
}
